// not an actual model but a variation
// modifies base Landmark to render with LayoutFilterLandmarkRenderer so
// that the landmark is not movable

import Landmark from '../landmark'
import LayoutFilterLandmarkRenderer from '../../utilities/layout-filters/landmark_renderer';

export default class LayoutFilerLandmark extends Landmark {
  static fromAttributes({ id, rotation, width, height, top_left_x, top_left_y, svg_url, label, filename }) {
    return new LayoutFilerLandmark(
      id,
      rotation,
      width,
      height,
      top_left_x,
      top_left_y,
      svg_url,
      label,
      filename
    );
  }

  renderOn(canvas) {
    this.renderer = new LayoutFilterLandmarkRenderer(this);
    this.renderer.setCanvas(canvas).render();
  }
}
